<template>

  <div class="login" v-if="!authenticated">
    <div id="sherpa_logo" class="w3-center">
      <img src="@/assets/media/logo_sherpa.png" class="w3-image" alt="logo sherpa">
    </div>
    <div id="form-login">
      <div>
        <form @submit.prevent="login">
          <transition name="fade" mode="out-in">
            <div v-if="langOptions" class="w3-section">
              <label>{{ $ml.get('language') }}</label>
              <multiselect
                v-model="lang"
                :options="langOptions"
                :placeholder="$ml.get('select')"
                :selectLabel="$ml.get('enterForSelect')"
                :deselectLabel="$ml.get('enterForDelete')"
                :custom-label="langName"
                :allow-empty="false"
                @input="valueChanged()"
                @open="openValue"
                @close="closeValue">
                  <span v-bind:class="{'active':isOpen==true}" class="arrow" slot="caret"><i class="fa fa-angle-down fa-2x"></i></span>
              </multiselect>
            </div>
            <spinner-loading v-else :line-size='2' :size="23" line-fg-color='#5dbecd' />
          </transition>
          <div class="w3-section">
            <label class="capitalize">{{ $ml.get('username') }}</label>
            <input class="w3-input Input-Background" type="text" name="username" v-model="username">
          </div>
          <div class="w3-section">
            <label class="capitalize">{{ $ml.get('password') }}</label>
            <input class="w3-input Input-Background" type="password" name="password" v-model="password">
          </div>
          <div id="contenidor-submit">
            <button id="submit" type="submit" class="w3-btn">
              <transition name="fade" mode="out-in">
                <spinner-loading v-if="authStatus === 'loading'" :line-size='2' :size="23" line-fg-color='#5dbecd' />
                <span v-else class="capitalize">{{ $ml.get('enter') }}</span>
              </transition>
            </button>
          </div>
          <div class="errors">
            <transition name="fade" mode="out-in">
              <span v-if="!dataFilled" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('errorLoginEmpty') }}.
              </span>
              <span v-else-if="authStatus === '401'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error401') }}.
              </span>
              <span v-else-if="authStatus && authStatus !== 'success' && authStatus !== 'loading'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error500') }}.
              </span>
            </transition>
          </div>
        </form>
      </div>
    </div>
    <div id="footer-sidebar" class="w3-center">
      <img src="@/assets/media/logo.png" class="w3-image" alt="logo mountdata">
      <div id="footer-info">
        <p>
          {{ $ml.get('allRightsReserved') }}<br />
          {{ $ml.get('registeredTrademark') }}<br />
          v{{version}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-definition-utils/src/utils/multiselect' // 'vue-multiselect ^2.1.6' component with TMD modifications
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'
import * as api from '@/utils/api'

export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      dataFilled: true,
      // variables select idioma
      langOptions: null,
      lang: '',
      isOpen: false
    }
  },
  components: {
    Multiselect
  },
  methods: {
    langName (language) {
      return this.$ml.get(language)
    },
    valueChanged () {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`, { lang: this.lang, ml: this.$ml })
    },
    login () {
      this.dataFilled = true
      if (this.username.trim() !== '' && this.password.trim() !== '') {
        const { username, password } = this
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_REQUEST}`, { username, password })
      } else {
        this.dataFilled = false
      }
    },
    closeValue () {
      this.isOpen = false
    },
    openValue () {
      this.isOpen = true
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [
      `${authTypes.AUTH_STATUS}`
    ]),
    authenticated () {
      return this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_AUTHENTICATED}`]
    },
    version () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_PACKAGE_VERSION}`]
    }
  },
  beforeMount () {
    this.lang = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`]
    if (!this.$store.getters[`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_AUTHENTICATED}`]) {
      this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, {id: 'login', name: 'Login'})
    }
    this.username = Vue.config.sherpaCrm.USER_ADMIN
    this.password = Vue.config.sherpaCrm.PSWD_ADMIN

    api.call({access: api.ACCESS_LANG, url: '/auth/languages', method: 'POST'})
      .then(resp => {
        this.langOptions = resp
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      })
      .catch(err => {
        // open error service dialog
        this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, {err}, {root: true})
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      })
  },
  watch: {
    authenticated (authenticated) {
      if (!authenticated) {
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`, {id: 'login', name: 'Login'})
      }
    }
  }
}
</script>

<style lang="scss">
#sidebar-login {
  position: fixed;
  top: 0;
  bottom: 0;
  min-width: 440px;
  background-color: #fff;
  z-index: 1;

  &.logged {
    min-width: 100px;
  }
}

#sherpa_logo {
  margin-top: 78px;

  img {
    width: 160px;
  }
}

#campaign {
  width: 183px;
  height: 45px;
  padding: 13px 19px 14px 22px;
  background-color: #fbbd2d;
  margin: 0 auto;
}

#campaign .Campaign {
  text-transform: uppercase;
  font-family: 'Barlow', sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 8px;
  text-align: center;
  color: #fefefe;
}

#form-login {
  margin-top: 76px;
}

#form-login>div {
  width: 400px;
  margin: 0 auto;
}

#form-login label {
  text-transform: capitalize;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: 0.5px;
  color: #342d38;
  height: 20px;
}

#form-login .Input-Background {
  width: 100%;
  height: 40px;
  border-radius: 3px;
  background-color: #ffffff;
  background-color: var(--white);
  border: solid 1px #e8e8e8;
  font-size: 14px;
}

#form-login .w3-section {
  margin-top: 18.5px !important;
}

/* .Forgot-username-For {
  width: 209px;
  height: 14px;
} */

.Forgot-username-For a {
  font-family: Barlow;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #554b5a;
}

.Forgot-username-For a:last-child {
  margin-left: 5px;
}

#Check-label {
  margin-top: 42px;
}

#Check-label input {
  font-family: Barlow;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #342d38;
}

.capitalize {
  text-transform: capitalize;
}

#contenidor-submit {
  margin-top: 20px;
}

#submit {
  width: 100%;
  border-radius: 5px;
  background-color: #21b7c9;
  padding: 9px 40px 9px;
}

#submit span {
  font-family: Capriola;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

#footer-sidebar {
  margin-top: 20px;
}

#footer-sidebar img {
  max-width: 177px;
}

#footer-sidebar div#footer-info {
  margin-top: 16px;
  font-family: Barlow;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: normal;
  color: #554b5a;
}

.Is-there-a-secret-to {
  margin-top: 159px;
  font-family: Barlow;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #ffffff;
  padding: 0 30px;
  display: none;
}

#rest-pantalla .Rectangle-3 {
  max-width: 183px;
  height: 42px;
  border-radius: 8px;
  border: solid 2px #ffffff;
  margin: 0 auto;
}

#rest-pantalla .Rectangle-3 span {
  font-family: Capriola;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 5px;
}

.formErrors {
  vertical-align: middle;
  padding:11px 20px;
  border-radius: 5px;
  color: #fff;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  background-color: #cf0000;
  float: left;
  width: 100%;
  margin-top: 10px;

  i {
    vertical-align: middle;
    margin-right: 5px;
  }

  .sherpa {
    font-size: 1em;
    position: relative;
    top: 2px;
    margin-right:5px;
  }
}

@media only screen and (max-width: 768px) {
  #rest-pantalla {
    display: none;
  }
}
</style>

<style>
.multiselect__tags {
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  font-size: 16px;
}
.multiselect__tags .multiselect__single {
  overflow-x: hidden;
}
.multiselect__tag {
  margin-bottom: 0;
}
.multiselect__option--selected {
  background-color: #dddddd;
}
.arrow {
  position: absolute;
  right: 10px;
  top: 5px;
  color: #ffbd42;
  transition: transform .2s;
}
.arrow.active {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.choiceWithTask {
  float: left;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue